import React from 'react';

export const OnOffIcon:React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" viewBox="0 0 20 21">
      <path fill="#FF7319" d="M17.036 4.348L14.358 6.91c1.013 1.076 1.576 2.498 1.576 3.976-.02 1.56-.654 3.05-1.765 4.147-1.11 1.096-2.609 1.71-4.17 1.71-1.56 0-3.058-.614-4.169-1.71-1.11-1.097-1.745-2.587-1.765-4.147 0-1.478.563-2.9 1.576-3.976L2.958 4.348c-.923.822-1.663 1.83-2.173 2.956S.008 9.65 0 10.887c0 5.086 4.477 9.21 10 9.21s10-4.124 10-9.21c-.009-1.237-.277-2.458-.788-3.584-.51-1.127-1.252-2.133-2.176-2.955z"/>
      <path fill="#FF7319" d="M8.665 10.453V0h2.734v10.453H8.665z"/>
    </svg>
  )
}